import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useCart } from 'Checkout/Hooks/useCart'
import { Button } from 'reactstrap'
import AlertErrors from 'Shared/Alert/AlertErrors'
import ConfirmRemoveModal from './ConfirmRemoveModal'
import CompleteReservationButton from 'Checkout/Components/Cart/CompleteReservationButton'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import ReservationContent from 'Checkout/Components/Shared/CartSummary/ReservationContent'
import ReservationDetailItem from 'Shared/ReservationDetailItem'

const Reservation = ({ reservation }) => {
  const { fillCurrentReservationFromCart, removeReservation } = useCart()
  const [isOpenRemoveModal, setOpenRemoveModal] = useState(false)
  const { nanoId, isSiteLock, pricing, rate, site, autoAssign } = reservation
  const groupErrors = useSelector(state => {
    if (state.cart.reservationsValidate.loading) return null

    return state.cart.reservationsValidate.data.errorsGroup?.find(error => error.key === nanoId)
  })
  const items = pricing?.items || []
  const placeName = (autoAssign === 'auto' || !site) ? rate?.name : site?.name
  const pricingTierPrice = items.find(item => item.itemableType === 'pricing_tier')?.base?.display
  const hasErrors = groupErrors?.errors?.length > 0
  const icon = isSiteLock ? 'lock' : null

  const onEdit = () => fillCurrentReservationFromCart(nanoId, { withRedirectTo: 'search' })

  const onConfirm = () => {
    removeReservation(nanoId)
    toggleRemoveModal()
  }

  const toggleRemoveModal = () => setOpenRemoveModal(prevState => !prevState)

  return (
    <div className="reservation border border-2 px-4 py-3 rounded shadow-sm">
      <ReservationDetailItem hideColon icon={icon} itemName={placeName} value={pricingTierPrice}
                             valueClass="text-gray" />

      <ReservationContent displayIcon={false} reservation={reservation} />

      <ReservationDetailItem hideColon value={pricing?.subtotal?.display} valueClass="fw-bold" />

      {hasErrors && <AlertErrors errors={groupErrors?.errors} />}

      <div className="d-flex gap-4">
        {hasErrors ? (
          <CompleteReservationButton groupErrors={groupErrors} nanoId={nanoId} />
        ) : (
          <Button className="border-0" color="dark-blue" onClick={onEdit} outline>
            <FontAwesomeIcon className="me-2" icon="pen" size="sm" />

            Edit
          </Button>
        )}

        <Button className="border-0" color="danger" onClick={toggleRemoveModal} outline>
          <FontAwesomeIcon className="me-2" icon="trash" size="sm" />

          Remove
        </Button>
      </div>

      <ConfirmRemoveModal isOpen={isOpenRemoveModal} onConfirm={onConfirm} placeName={placeName}
                          reservation={reservation} toggle={toggleRemoveModal} />
    </div>
  )
}

export default Reservation
